import PropTypes, { number, string } from 'prop-types';

/**
 * Dropdown input component
 * 
 * @param {object} props
 * @param {string} props.id - dropdown ID
 * @param {string} props.name - dropdown name (used for extracting form data)
 * @param {label} props.label - dropdown label
 * @param {Array} props.options - Array of dropdown option objects. Each option object should have a "value" and "label" attribute.
 * @param {string} props.className - additional className to be applied to the select element
 * @param {Function} props.onChange - function that runs when an option is selected from the dropdown
 * @param {boolean} props.required - true if dropdown is a required form field, false otherwise
 * @param props.value - the default value of the dropdown, if provided
 */
const Dropdown = ({ id, name, label, options, className, onChange, required, value, style }) => {
    return (
        <div className='dropdown-input'>
            {label &&
                <label className="input-label" htmlFor={id}>
                    {required ? `${label} *` : label}
                </label>
            }
            <select id={id} name={name} className={className} onChange={onChange} required={required} value={value} style={style}>
                <option id='blank-option' disabled selected></option>
                {options.map((option, i) => (
                    <option id={`${id}-option[${i}]`} key={i} value={option.value}>{option.label}</option>
                ))}
            </select>
        </div>
    );
};

Dropdown.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.oneOfType([string, number]).isRequired,
        label: PropTypes.string.isRequired,
    })).isRequired,
    className: PropTypes.string,
    onChange: PropTypes.func,
    required: PropTypes.bool,
    value: PropTypes.oneOfType([string, number]),
};

export default Dropdown;